import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import {
  IExternalEmailTemplate,
  IExternalEmailTemplateSummary,
} from "./externalEmailTemplates.types"
import { EmailTemplateSender } from "./emailTemplates.types"
import {
  GetExternalEmailTemplatesQuery,
  GetExternalEmailTemplateByIdQuery,
} from "@/api/hasura/generated/graphql"
import { dayjsOrNull } from "@/helpers/dateHelper"

export type IExternalEmailTemplateSummaryRaw =
  GetExternalEmailTemplatesQuery["email_templates_ext"][0]
export type IExternalEmailTemplateRaw =
  GetExternalEmailTemplateByIdQuery["email_templates_ext"][0]

const SENDERS: Record<string, EmailTemplateSender> = {
  JUNIFER: EmailTemplateSender.JUNIFER,
}

// Unknown senders still render, so a new source system added upstream does not
// break the whole list.
function toSender(sender: unknown): EmailTemplateSender {
  return SENDERS[String(sender)] ?? EmailTemplateSender.EXTERNAL
}

function toSummary(
  data: IExternalEmailTemplateSummaryRaw,
): IExternalEmailTemplateSummary {
  return {
    id: Number(data.id),
    name: data.name,
    subject: data.subject,
    sender: toSender(data.sender),
    version: data.version,
    replyToAddress: data.reply_to_address ?? null,
    createdAt: dayjsOrNull(data.created_at),
    updatedAt: dayjsOrNull(data.updated_at),
  }
}

export const ExternalEmailTemplateSummaryParser: IParser<
  IExternalEmailTemplateSummary,
  IExternalEmailTemplateSummaryRaw
> = {
  toDomain(
    data: IExternalEmailTemplateSummaryRaw,
  ): IExternalEmailTemplateSummary {
    try {
      return toSummary(data)
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export const ExternalEmailTemplateParser: IParser<
  IExternalEmailTemplate,
  IExternalEmailTemplateRaw
> = {
  toDomain(data: IExternalEmailTemplateRaw): IExternalEmailTemplate {
    try {
      return {
        ...toSummary(data),
        body: data.body,
      }
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
